export interface Country {
  countryCode: string;
  cities: City[];
  isDeletable: boolean;
}

export interface City {
  uuid: string;
  name: string;
  offices: Office[];
  isDeletable: boolean;
}

export interface Office {
  name: string;
  address: string;
  isDeletable: boolean;
}

export interface CompanyStepData {
  id?: number;
  readonly company: string;
  readonly website?: string;
  readonly street?: string;
  readonly city?: string;
  readonly zip?: string;
}

export interface CountryStepData {
  readonly countries: Array<Country>;
}

export interface CityStepData {
  readonly cities: Record<string, City[]>;
}

export interface OfficeStepData {
  readonly offices: Record<string, Office[]>;
}

export const isValidCompanyStepData = (data: unknown): data is CompanyStepData => {
  return !!data;
};
